module.exports = __webpack_public_path__ + "img/lock.59be402e.svg";